import { MultiValue, SingleValue } from 'react-select';

type ComboboxOption = { value: string; label: string };

/**
 * Maps a Combobox selection to the form value Enum writes (code string,
 * or an array of codes for sets). Cleared selections become '' / [].
 */
function mapComboboxSelectionToFormValue(
    newValue: MultiValue<ComboboxOption> | SingleValue<ComboboxOption> | undefined,
    isSet: boolean,
): string | string[] {
    if (newValue === null || newValue === undefined) {
        return isSet ? [] : '';
    }

    if (isSet) {
        const values = newValue as ComboboxOption[];
        return values?.map(v => v.value) || [];
    }

    const singleValue = newValue as SingleValue<ComboboxOption>;
    return singleValue?.value || '';
}

export { mapComboboxSelectionToFormValue };
